{
  "_meta": {
    "_comment": "Admin vendors namespace. Phase 18 Task 34 added detail.tabs.integration. vg-binding: P18.D-21 | vg-binding: PLAN:task-34",
    "locale": "fr"
  },
  "list": {
    "page": {
      "heading": "Fournisseurs",
      "subtitle": "Gérez l'identité, le KYC, l'activation, la capacité et les risques des fournisseurs. Cliquez sur une ligne pour accéder à la page de détail."
    },
    "filter": {
      "showClosed": "Afficher les fournisseurs fermés"
    },
    "empty": {
      "message": "Aucun fournisseur ne correspond à vos filtres."
    },
    "legend": {
      "label": "Légende des lignes :",
      "suspended": "Suspendu",
      "atRisk": "À risque",
      "lowRating": "Faible note (< 0,5)",
      "pendingActivation": "Activation en attente",
      "ariaLabel": "Légende des couleurs de ligne"
    },
    "wallet": {
      "onHold": "En attente",
      "open": "Ouvert",
      "onHoldTitle": "Portefeuille bloqué — paiements suspendus par l'administrateur"
    },
    "kyc": {
      "pendingTitle": "Paiement bloqué. Commandes autorisées."
    },
    "capabilities": {
      "pendingTitle": "Propositions de capacités en attente"
    },
    "toast": {
      "actionRequiresDetailTitle": "Action requiert la page de détail",
      "actionRequiresDetailDesc": "Ouvrez la page de détail du fournisseur pour effectuer cette action. La fenêtre modale de masse arrive en Wave 5.",
      "activationQueueTitle": "Approuver dans la file d'attente",
      "activationQueueDesc": "File d'attente des fournisseurs ouverte — cliquez sur la ligne du fournisseur pour examiner et approuver l'activation.",
      "suspendedTitle": "Fournisseur suspendu",
      "reactivatedTitle": "Fournisseur réactivé",
      "networkError": "Erreur réseau — vérifiez la connexion",
      "noVendorsTitle": "Aucun fournisseur sélectionné",
      "noVendorsDesc": "Sélectionnez au moins un fournisseur pour exécuter cette action groupée.",
      "reasonRequiredTitle": "Motif requis",
      "reasonRequiredDesc": "Veuillez fournir un motif de 10 à 500 caractères pour continuer.",
      "dualApprovalTitle": "Double approbation requise",
      "dualApprovalDesc": "Demande {{approvalId}} mise en file (SLA {{slaMinutes}} min, {{vendorCount}} fournisseurs).",
      "jobQueuedTitle": "Tâche en file d'attente",
      "jobQueuedDesc": "Tâche en arrière-plan {{jobId}}. Suivi via {{pollUrl}}.",
      "bulkCompleteTitle": "Action groupée terminée",
      "bulkCompleteDesc": "{{count}} fournisseurs mis à jour.",
      "partialSuccessTitle": "Succès partiel",
      "partialSuccessDesc": "{{succeeded}} réussi(s), {{failed}} échoué(s).",
      "bulkFailedTitle": "Échec de l'action groupée"
    },
    "bulkActions": {
      "suspend": "Suspendre",
      "suspendLabel": "Suspendre les fournisseurs",
      "activate": "Activer",
      "activateLabel": "Activer les fournisseurs",
      "holdWallet": "Bloquer le portefeuille",
      "holdWalletLabel": "Bloquer le portefeuille des fournisseurs",
      "releaseWallet": "Débloquer le portefeuille",
      "releaseWalletLabel": "Débloquer le portefeuille des fournisseurs",
      "exportCsv": "Exporter CSV",
      "exportLabel": "Exporter les fournisseurs",
      "perVendorSuspendLabel": "Suspendre le fournisseur",
      "perVendorReactivateLabel": "Réactiver le fournisseur"
    },
    "actions": {
      "confirm": "Confirmer",
      "vendorSettings": "Paramètres Fournisseur",
      "createVendor": "Créer un fournisseur",
      "importVendors": "Importer"
    }
  },
  "listColumns": {
    "headers": {
      "name": "Fournisseur",
      "status": "Statut",
      "wallet": "Portefeuille",
      "kyc": "KYC",
      "rating": "Note",
      "utilization": "Utilisation",
      "pendingOrders": "En attente",
      "sla": "SLA",
      "backOrder": "Reliquat",
      "totalEarned": "Total gagné",
      "pendingPayout": "Paiement en attente",
      "atRisk": "À risque",
      "capPending": "Capacité en attente",
      "region": "Région",
      "created": "Créé le"
    },
    "filters": {
      "search": {
        "label": "Rechercher",
        "placeholder": "Nom, e-mail, téléphone, ID…"
      },
      "status": {
        "label": "Statut",
        "options": {
          "pending_activation": "En attente d'activation",
          "active": "Actif",
          "inactive": "Inactif",
          "suspended": "Suspendu",
          "closed": "Fermé"
        }
      },
      "wallet": {
        "label": "Portefeuille",
        "options": {
          "hold": "En attente",
          "open": "Ouvert"
        }
      },
      "kyc": {
        "label": "KYC",
        "options": {
          "approved": "Approuvé",
          "pending": "En attente",
          "rejected": "Rejeté"
        }
      },
      "atRisk": {
        "label": "Niveau de risque",
        "options": {
          "low": "Faible",
          "medium": "Moyen",
          "high": "Élevé"
        }
      },
      "region": {
        "label": "Région",
        "placeholder": "Code pays / région"
      }
    }
  },
  "rowMenu": {
    "menuAria": "Actions du fournisseur {{id}}",
    "triggerAria": "Ouvrir les actions pour le fournisseur {{id}}",
    "items": {
      "view": "Voir le détail",
      "approve_kyc": "Approuver le KYC",
      "approve_activation": "Approuver l'activation",
      "capability_review": "Révision des capacités",
      "acknowledge_at_risk": "Confirmer le risque",
      "reactivate": "Réactiver",
      "suspend": "Suspendre"
    }
  },
  "tabs": {
    "listAria": "Onglets de la liste des fournisseurs",
    "countAria": "{{count}} fournisseurs",
    "labels": {
      "all": "Tous",
      "pending_activation": "Activation en attente",
      "active": "Actif",
      "inactive": "Inactif",
      "suspended": "Suspendu",
      "pending_cost_approvals": "Approbations de coûts en attente",
      "pending_capabilities": "Capacités en attente",
      "at_risk": "À risque"
    },
    "descriptions": {
      "all": "Tous les fournisseurs quel que soit leur statut.",
      "pending_activation": "Fournisseurs en attente d'approbation par un administrateur. Les nouveaux fournisseurs apparaissent ici jusqu'à leur activation.",
      "pending_cost_approvals": "Fournisseurs avec des demandes d'approbation de coûts ouvertes. Issu du backend Phase 7.",
      "pending_capabilities": "Fournisseurs avec des propositions de capacités en attente. Chaque proposition nécessite une révision par un administrateur.",
      "at_risk": "Fournisseurs signalés par l'analyse des risques. Inclut : faible note, taux de rejet élevé, pic de plaintes."
    }
  },
  "pinnedOverview": {
    "cards": {
      "profile": "Profil",
      "performance": "Performance",
      "capacity": "Capacité",
      "financial": "Financier"
    },
    "profile": {
      "email": "E-mail",
      "phone": "Téléphone",
      "country": "Pays",
      "primaryContact": "Contact principal",
      "tier": "Niveau",
      "yearsActive": "Années d'activité"
    },
    "performance": {
      "rating": "Note",
      "delta30d": "Δ 30j",
      "orders30d": "Commandes 30j",
      "rejectionRate": "Taux de rejet",
      "slaCompliance": "Conformité SLA",
      "manualAdjust": "Ajustement manuel de la note"
    },
    "capacity": {
      "costGatedMsg": "Accès restreint — demandez la permission VIEW_FINANCIAL_COST pour voir l'utilisation de la capacité.",
      "slots": "emplacements",
      "frozen": "gelé(s)"
    },
    "financial": {
      "wallet": "Portefeuille",
      "pendingPayout": "Paiement en attente",
      "earnings30d": "Revenus 30j",
      "outstandingInvoice": "Facture impayée"
    }
  },
  "detail": {
    "tabs": {
      "ariaLabel": "Sections de détail du vendeur",
      "locations": "Emplacements",
      "capabilities": "Capacités",
      "products": "Produits",
      "pending-cost-approvals": "Approbations de coûts",
      "recent-orders": "Commandes récentes",
      "financial": "Finances",
      "activity-log": "Activité",
      "notes": "Notes",
      "kyc": "KYC",
      "staff-accounts": "Personnel",
      "sla-chart": "SLA",
      "integration": "Intégration",
      "badgeNew": "NOUVEAU"
    },
    "backLink": "Retour aux vendeurs",
    "loading": "Chargement du vendeur…",
    "error": {
      "missingId": "Identifiant vendeur manquant dans la route — impossible d'afficher le détail.",
      "loadFail": "Erreur lors du chargement du vendeur : {{message}}",
      "noData": "Aucune donnée vendeur retournée.",
      "impersonateNoUrl": "Cookie d'usurpation défini mais aucune URL de redirection retournée — ouvrez le portail vendeur manuellement.",
      "cannotImpersonate": "Votre rôle ne peut pas usurper l'identité des vendeurs."
    },
    "ratingModal": {
      "title": "Remplacement manuel de la note",
      "description": "Cette action est consignée dans le journal d'audit vendeur avec les valeurs avant / après et votre motif. Le remplacement reste actif jusqu'à ce qu'un autre administrateur le supprime.",
      "newRatingLabel": "Nouvelle note : {{value}} / 5",
      "reasonLabel": "Motif (min 10 caractères)",
      "reasonTooShort": "Le motif doit comporter au moins 10 caractères (obligation d'audit).",
      "unknownError": "Erreur inconnue",
      "cancel": "Annuler",
      "saving": "Enregistrement…",
      "save": "Enregistrer le remplacement"
    },
    "confirmDialog": {
      "reasonLabel": "Motif (facultatif)",
      "unknownError": "Erreur inconnue",
      "cancel": "Annuler",
      "working": "En cours…"
    },
    "walletAdjustPlaceholder": {
      "title": "Ajustement du portefeuille",
      "description": "La fenêtre complète d'ajustement du portefeuille vendeur sera disponible dans la tâche 26 (§7.1). Ce composant signale l'action pour l'instant — le flux de mutation réel arrivera à la Wave 7.",
      "close": "Fermer"
    },
    "confirm": {
      "suspend": {
        "title": "Suspendre le vendeur",
        "body": "La suspension empêche l'acheminement de nouvelles commandes. Les commandes en cours ne sont pas annulées — elles continuent à être traitées.",
        "cta": "Confirmer la suspension"
      },
      "reactivate": {
        "title": "Réactiver le vendeur",
        "body": "Réactivez ce vendeur pour que les nouvelles commandes puissent lui être acheminées.",
        "cta": "Confirmer la réactivation"
      },
      "walletHoldOn": {
        "title": "Bloquer le portefeuille vendeur",
        "body": "Bloquez le portefeuille — les paiements et les retraits sont bloqués jusqu'à la libération.",
        "cta": "Bloquer le portefeuille"
      },
      "walletHoldOff": {
        "title": "Libérer le portefeuille vendeur",
        "body": "Libérez le blocage du portefeuille pour que les paiements et les retraits reprennent.",
        "cta": "Libérer le portefeuille"
      }
    }
  },
  "stickyHeader": {
    "statusLabels": {
      "Active": "Actif",
      "Pending": "Activation en attente",
      "PendingActivation": "Activation en attente",
      "Suspended": "Suspendu",
      "Inactive": "Inactif",
      "AtRisk": "À risque"
    },
    "rating": {
      "manualTitle": "Remplacement manuel de la note — actuel {{value}} / 5",
      "currentTitle": "Note actuelle {{value}} / 5",
      "manual": "Manuel",
      "manualAdjust": "Ajustement manuel"
    },
    "online": {
      "online": "En ligne",
      "lastSeen": "Vu la dernière fois le {{date}}",
      "offline": "Hors ligne"
    },
    "actions": {
      "edit": "Modifier",
      "reactivate": "Réactiver",
      "suspend": "Suspendre",
      "releaseWallet": "Libérer le portefeuille",
      "holdWallet": "Bloquer le portefeuille",
      "loginAsVendor": "Se connecter en tant que vendeur"
    },
    "walletHoldBadge": "Portefeuille bloqué"
  },
  "reviewDrawer": {
    "title": "Révision du vendeur",
    "close": "Fermer",
    "ariaLabel": "Panneau de révision du vendeur",
    "closeAriaLabel": "Fermer le panneau vendeur",
    "notFound": "Vendeur introuvable.",
    "toast": {
      "loadFail": "Impossible de charger le vendeur",
      "networkError": "Erreur réseau",
      "unknown": "Inconnu",
      "approveFail": "Approbation échouée",
      "approveSuccess": "Vendeur approuvé",
      "approveSuccessDesc": "{{displayName}} est maintenant actif.",
      "rejectReasonShort": "Motif de rejet trop court",
      "rejectReasonShortDesc": "Minimum 10 caractères requis.",
      "rejectFail": "Rejet échoué",
      "rejectSuccess": "Vendeur rejeté",
      "rejectSuccessDesc": "Notification par e-mail en file d'attente ; délai de grâce appliqué."
    },
    "profile": {
      "heading": "Profil",
      "displayName": "Nom d'affichage",
      "phone": "Téléphone",
      "country": "Pays",
      "status": "Statut",
      "applied": "Candidature",
      "lastReject": "Dernier rejet"
    },
    "survey": {
      "heading": "Réponses au sondage",
      "empty": "Le vendeur n'a pas complété le sondage d'inscription."
    },
    "actions": {
      "reject": "Rejeter",
      "approve": "Approuver",
      "rejectReasonLabel": "Motif de rejet (10-2000 caractères)",
      "rejectReasonPlaceholder": "Expliquez pourquoi cette candidature vendeur est rejetée. Envoyé par e-mail.",
      "cancel": "Annuler",
      "confirmReject": "Confirmer le rejet"
    },
    "registration": {
      "heading": "Détails de l'inscription",
      "businessName": "Nom commercial",
      "legalName": "Raison sociale",
      "timezone": "Fuseau horaire",
      "shippingMode": "Mode d'expédition",
      "techniques": "Techniques",
      "warehouse": "Entrepôt"
    }
  },
  "sections": {
    "activityLog": {
      "title": "Journal d'activité",
      "categoryFilter": {
        "ariaLabel": "Filtre par catégorie d'activité",
        "admin_action": "Actions administrateur",
        "vendor_action": "Actions fournisseur",
        "system_event": "Événements système",
        "order_lifecycle": "Cycle de vie des commandes"
      },
      "loading": "Chargement de l'activité…",
      "pendingLabel": "Aucune activité — endpoint en cours de développement.",
      "empty": "Aucune activité ne correspond au filtre actuel.",
      "actorPrefix": "Par {{actor}}",
      "loadingMore": "Chargement…",
      "loadMore": "Charger plus",
      "unknownAction": "Activité",
      "actions": {
        "VENDOR_CREATED": "Fournisseur créé",
        "VENDOR_SUSPENDED": "Fournisseur suspendu",
        "VENDOR_REACTIVATED": "Fournisseur réactivé",
        "VENDOR_ACTIVATION_APPROVED": "Activation du fournisseur approuvée",
        "VENDOR_ACTIVATION_REJECTED": "Activation du fournisseur refusée",
        "VENDOR_AT_RISK_ACKNOWLEDGED": "Alerte de risque prise en compte",
        "VENDOR_BANK_VERIFIED": "Compte bancaire vérifié",
        "VENDOR_BANK_REJECTED": "Compte bancaire refusé",
        "VENDOR_BULK_IMPORT": "Importé en masse",
        "VENDOR_CAPABILITY_ASSIGNED": "Capacité attribuée",
        "VENDOR_CAPABILITY_PROPOSAL_APPROVED": "Proposition de capacité approuvée",
        "VENDOR_CAPABILITY_PROPOSAL_REJECTED": "Proposition de capacité refusée",
        "VENDOR_COST_APPROVAL_APPROVED": "Changement de coût approuvé",
        "VENDOR_COST_APPROVAL_REJECTED": "Changement de coût refusé",
        "VENDOR_WALLET_ADJUST_REQUESTED": "Ajustement du portefeuille demandé",
        "VENDOR_WALLET_ADJUST_APPLIED": "Ajustement du portefeuille appliqué",
        "VENDOR_UPDATED": "Profil fournisseur mis à jour",
        "KYC_DOCUMENT_APPROVED": "Document KYC approuvé",
        "KYC_DOCUMENT_REJECTED": "Document KYC refusé",
        "KYC_DOCUMENT_VIEWED": "Document KYC consulté",
        "AUTH_LOGIN": "Connexion",
        "AUTH_LOGOUT": "Déconnexion",
        "AUTH_VENDOR_APPROVE": "Candidature fournisseur approuvée",
        "AUTH_VENDOR_REJECT": "Candidature fournisseur refusée",
        "AUTH_VENDOR_REAPPLY": "Nouvelle candidature du fournisseur",
        "ORDER_ITEM_VENDOR_OVERRIDDEN": "Fournisseur de l'article remplacé",
        "WITHDRAW_PERMISSION_UPDATED": "Autorisation de retrait mise à jour",
        "GDPR_GRANDFATHER_EXPIRED": "Période de grâce du consentement expirée",
        "AUTH_REFRESH_FAILED": "Échec du rafraîchissement de session",
        "AUTH_REFRESH": "Session rafraîchie",
        "AUTH_2FA_VERIFY": "Double authentification vérifiée",
        "AUTH_2FA_SETUP": "Double authentification configurée",
        "AUTH_2FA_DISABLED": "Double authentification désactivée",
        "AUTH_2FA_CHALLENGE": "Défi de double authentification envoyé",
        "AUTH_USER_2FA_RESET": "Double authentification réinitialisée par l'administrateur",
        "AUTH_LOGIN_FAILED": "Échec de la connexion",
        "AUTH_LOGIN_LOCKED": "Compte verrouillé après des échecs de connexion",
        "AUTH_PASSWORD_CHANGE": "Mot de passe modifié",
        "AUTH_REGISTER": "Compte créé",
        "AUTH_PROFILE_UPDATE": "Profil mis à jour",
        "AUTH_BILLING_UPDATE": "Informations de facturation mises à jour",
        "AUTH_USER_UPDATE": "Compte mis à jour",
        "AUTH_USER_SUSPEND": "Compte suspendu",
        "AUTH_USER_UNSUSPEND": "Compte réactivé",
        "AUTH_USER_ROLE_GRANT": "Rôle attribué",
        "AUTH_USER_ROLE_REVOKE": "Rôle révoqué",
        "AUTH_SESSION_REVOKED": "Session révoquée",
        "AUTH_IMPERSONATE_START": "Début de l'usurpation d'identité",
        "AUTH_SURVEY_SUBMIT": "Enquête envoyée",
        "AUTH_WS_SUBSCRIBE_DENIED": "Abonnement temps réel refusé",
        "vendor.capacity.current_active_changed": "Capacité active modifiée",
        "vendor.assignment.suspension_cascade": "Affectations déplacées après suspension",
        "payout.approved": "Paiement approuvé",
        "payout.rejected": "Paiement refusé",
        "payout.mark_transferred": "Paiement marqué comme transféré",
        "support_ticket.created": "Ticket de support créé",
        "support_ticket.updated": "Ticket de support mis à jour",
        "support_ticket.escalated": "Ticket de support escaladé",
        "support_ticket_message.created": "Réponse au ticket de support",
        "CATEGORY_CREATED": "Catégorie créée",
        "CATEGORY_UPDATED": "Catégorie mise à jour",
        "CATEGORY_REORDERED": "Catégories réordonnées",
        "COLLECTION_CREATED": "Collection créée",
        "COLLECTION_UPDATED": "Collection mise à jour",
        "COLLECTION_REORDERED": "Collections réordonnées",
        "OPTION_CREATED": "Option créée",
        "OPTION_UPDATED": "Option mise à jour",
        "OPTION_DELETED": "Option supprimée",
        "blueprint:create": "Blueprint créé",
        "blueprint:update": "Blueprint mis à jour",
        "products_special.create": "Produit spécial créé",
        "products_special.update_assignments": "Affectations de produits spéciaux mises à jour",
        "INVENTORY_STOCK_VIEW": "Stock consulté",
        "INVENTORY_OVERVIEW_VIEW": "Vue d'ensemble du stock consultée",
        "INVENTORY_REPORT_MOVEMENT_EXPORT": "Rapport des mouvements de stock exporté",
        "INVENTORY_REPORT_STOCK_LEVEL_EXPORT": "Rapport des niveaux de stock exporté",
        "INVENTORY_REPORT_AGING_EXPORT": "Rapport d'ancienneté du stock exporté",
        "INVENTORY_REPORT_VALUATION_EXPORT": "Rapport de valorisation du stock exporté",
        "INVENTORY_REPORT_TURNOVER_EXPORT": "Rapport de rotation du stock exporté",
        "FRAUD_SETTINGS_UPDATED": "Paramètres antifraude mis à jour",
        "ADMIN_ROLE_CREATE": "Rôle administrateur créé",
        "ADMIN_ROLE_DELETE": "Rôle administrateur supprimé",
        "settings.update": "Paramètres mis à jour",
        "EMERGENCY_MODE_ACTIVATED": "Mode d'urgence activé",
        "SYSTEM_BACKUP_TRIGGERED": "Sauvegarde système déclenchée",
        "LEGAL_ENTITY_CREATED": "Entité juridique créée",
        "merchant_invoice_created": "Facture marchand créée",
        "invoice_pdf_download": "PDF de facture téléchargé",
        "admin_invoice_pdf_download": "PDF de facture téléchargé par l'administrateur",
        "admin_payment_request_create": "Demande de paiement créée",
        "admin_payment_request_pdf_download": "PDF de demande de paiement téléchargé",
        "billing_address_create": "Adresse de facturation créée",
        "billing.mode.switched": "Mode de facturation changé",
        "billing.invoice.manually_generated": "Facture générée manuellement",
        "billing.refund_task.completed": "Tâche de remboursement terminée"
      },
      "fields": {
        "status": "Statut",
        "activation_status": "Statut d'activation",
        "kyc_status": "Statut KYC",
        "reason": "Motif",
        "rejectReason": "Motif du refus",
        "reject_reason": "Motif du refus",
        "note": "Note",
        "tier": "Niveau",
        "vendorTier": "Niveau",
        "amount": "Montant",
        "payout_blocked": "Paiements bloqués"
      }
    },
    "capabilities": {
      "title": "Capacités",
      "loading": "Chargement des capacités…",
      "pendingLabel": "Aucune capacité — endpoint en cours de développement.",
      "empty": "Aucune capacité enregistrée.",
      "status": {
        "approved": "Approuvé",
        "proposed": "Proposé",
        "rejected": "Rejeté"
      },
      "productCount": "{{count}} produits",
      "actions": {
        "approve": "Approuver",
        "reject": "Rejeter",
        "cancel": "Annuler",
        "confirmReject": "Confirmer le rejet"
      },
      "rejectReasonLabel": "Motif du rejet",
      "errors": {
        "reasonRequired": "Le motif du rejet est requis.",
        "unknown": "Erreur inconnue"
      }
    },
    "financial": {
      "title": "Finances",
      "costGate": "Les détails financiers sont restreints. Votre rôle n'inclut pas l'autorisation de consultation des coûts financiers. Contactez un Super Admin pour y accéder.",
      "loading": "Chargement des finances…",
      "noData": "Aucune donnée financière.",
      "subBlocks": {
        "earnings": "Revenus",
        "earningsPipeline": "Revenus en cours",
        "payouts": "Versements",
        "walletAdjustments": "Ajustements du portefeuille",
        "bankAccounts": "Comptes bancaires"
      },
      "earningsPipelineLabel": "En cours :",
      "noEarnings": "Aucune donnée de revenus.",
      "noPayouts": "Aucun versement planifié.",
      "noWalletAdjustments": "Aucun ajustement de portefeuille enregistré.",
      "noBankAccounts": "Aucun compte bancaire enregistré.",
      "createAdjustment": "+ Créer un ajustement",
      "earningsChartAriaLabel": "Graphique des revenus",
      "payoutStatus": {
        "paid": "Payé",
        "scheduled": "Planifié",
        "held": "En attente",
        "failed": "Échoué"
      },
      "defaultBadge": "Par défaut",
      "bankVerifiedBadge": "Vérifié",
      "bankPendingBadge": "En attente",
      "bankVerify": "Vérifier",
      "bankReview": "Revoir",
      "columns": {
        "date": "Date",
        "amount": "Montant",
        "status": "Statut",
        "reference": "Référence"
      }
    },
    "kyc": {
      "title": "KYC",
      "loading": "Chargement du KYC…",
      "pendingLabel": "Aucun dossier KYC — endpoint en cours de développement.",
      "noData": "Aucune donnée KYC.",
      "payoutsBlockedBanner": {
        "heading": "Versements bloqués.",
        "body": "Les fournisseurs non vérifiés peuvent toujours accepter des commandes ; les versements et retraits sont bloqués jusqu'à la vérification KYC."
      },
      "docLabels": {
        "business_license": "Licence commerciale",
        "tax_certificate": "Certificat fiscal",
        "identity": "Pièce d'identité (passeport / carte nationale)",
        "bank_proof": "Justificatif de compte bancaire"
      },
      "submittedAt": "Soumis le {{date}}",
      "reviewedAt": "Examiné le {{date}}",
      "viewDocument": "Voir le document",
      "approve": "Approuver",
      "reject": "Rejeter",
      "rejectConfirm": "Confirmer le rejet",
      "cancel": "Annuler",
      "rejectReasonPlaceholder": "Motif (min 10 caractères) — envoyé au fournisseur",
      "actionFailed": "Échec de l’action — veuillez réessayer"
    },
    "locations": {
      "title": "Sites",
      "loading": "Chargement des sites…",
      "pendingLabel": "Aucun site — endpoint en cours de développement.",
      "empty": "Aucun site enregistré pour ce fournisseur.",
      "badge": {
        "primary": "Principal",
        "frozen": "Gelé"
      },
      "freeze": {
        "working": "En cours…",
        "unfreeze": "Dégeler",
        "freeze": "Geler le site"
      },
      "confirmDialog": {
        "ariaLabel": "Confirmer le gel du site",
        "unfreezePrompt": "Dégeler ce site ? Les créneaux de capacité redeviennent réservables.",
        "freezePrompt": "Geler ce site ? Les autres sites du fournisseur ne sont pas affectés. Gel partiel — les commandes existantes se poursuivent.",
        "cancel": "Annuler",
        "confirm": "Confirmer"
      },
      "errors": {
        "unknown": "Erreur inconnue"
      }
    },
    "notes": {
      "title": "Notes",
      "subtitle": "Interne — visible uniquement par le personnel administrateur.",
      "loading": "Chargement des notes…",
      "pendingLabel": "Aucune note — endpoint en cours de développement.",
      "empty": "Aucune note interne enregistrée.",
      "addNoteLabel": "Ajouter une note interne",
      "saving": "Enregistrement…",
      "addNote": "Ajouter une note",
      "errors": {
        "unknown": "Erreur inconnue"
      }
    },
    "pendingCostApprovals": {
      "title": "Approbations de coûts en attente",
      "loading": "Chargement des propositions…",
      "pendingLabel": "Aucune demande d'approbation de coût — endpoint en cours de développement.",
      "empty": "Aucune proposition de modification de coût en attente.",
      "proposed": "Proposé le {{date}}",
      "proposedBy": "par {{name}}",
      "actions": {
        "approve": "Approuver",
        "reject": "Rejeter",
        "confirmReject": "Confirmer le rejet"
      },
      "rejectReasonLabel": "Motif",
      "errors": {
        "reasonRequired": "Le motif du rejet est requis.",
        "unknown": "Erreur inconnue"
      }
    },
    "products": {
      "title": "Produits",
      "loading": "Chargement des produits…",
      "pendingLabel": "Aucun produit — endpoint en cours de développement.",
      "empty": "Aucun produit pour l'instant.",
      "columns": {
        "sku": "SKU",
        "product": "Produit",
        "status": "Statut",
        "cost": "Coût"
      },
      "status": {
        "active": "Actif",
        "pendingReapproval": "En attente de réapprobation",
        "paused": "En pause"
      },
      "variantCount": "({{count}} variantes)",
      "showing": "Affichage de {{shown}} sur {{total}} produits."
    },
    "recentOrders": {
      "title": "Commandes récentes",
      "subtitle": "Les 20 dernières commandes. Consultez la page des commandes pour la liste complète.",
      "loading": "Chargement des commandes…",
      "pendingLabel": "Aucune commande récente — endpoint en cours de développement.",
      "empty": "Aucune commande récente.",
      "columns": {
        "reference": "Référence",
        "merchant": "Marchand",
        "status": "Statut",
        "total": "Total",
        "placed": "Date"
      },
      "viewAll": "Voir toutes les commandes →"
    },
    "shell": {},
    "slaChart": {
      "title": "Performance SLA",
      "rangeAriaLabel": "Plage SLA",
      "months": "{{count}} mois",
      "loading": "Chargement des données SLA…",
      "pendingLabel": "Aucune donnée SLA — endpoint en cours de développement.",
      "empty": "Aucune donnée SLA pour la plage sélectionnée.",
      "chartAriaLabel": "Graphique linéaire des performances SLA",
      "legend": {
        "fulfilment": "Taux d'exécution",
        "rejection": "Taux de rejet"
      }
    },
    "staffAccounts": {
      "title": "Comptes du personnel",
      "subtitle": "Lecture seule. La suspension est la seule modification que les administrateurs peuvent effectuer sur le personnel fournisseur.",
      "loading": "Chargement du personnel…",
      "pendingLabel": "Aucun membre du personnel — endpoint en cours de développement.",
      "empty": "Aucun compte personnel.",
      "columns": {
        "name": "Nom",
        "email": "E-mail",
        "role": "Rôle",
        "status": "Statut",
        "lastLogin": "Dernière connexion",
        "actions": "Actions"
      },
      "status": {
        "active": "Actif",
        "suspended": "Suspendu",
        "pending": "En attente"
      },
      "suspending": "Suspension…",
      "suspend": "Suspendre",
      "reactivating": "Réactivation…",
      "reactivate": "Réactiver",
      "errors": {
        "unknown": "Erreur inconnue"
      }
    },
    "feedback": {
      "defaultPending": "Fonctionnalité en cours de développement — aucune donnée disponible."
    }
  },
  "kycQueue": {
    "page": {
      "heading": "File d'attente KYC",
      "subtitle": "Chaque document est examiné individuellement (exigence de conformité —a). Le KYC bloque uniquement les paiements ; les vendeurs peuvent toujours recevoir des commandes avant approbation."
    },
    "payoutBanner": {
      "title": "Avis de paiement :",
      "body": "un ou plusieurs vendeurs de la liste ont les paiements bloqués car le KYC est incomplet. Les vendeurs peuvent toujours recevoir des commandes — seuls les paiements sont retenus jusqu'à ce que tous les documents requis soient approuvés."
    },
    "tabs": {
      "ariaLabel": "Filtrer par statut",
      "pending": "En attente",
      "approved": "Approuvé",
      "rejected": "Rejeté",
      "all": "Tous"
    },
    "search": {
      "label": "Rechercher",
      "placeholder": "Rechercher un vendeur ou un type de document…"
    },
    "docTypes": {
      "business_license": "Licence commerciale",
      "id_card": "Carte d'identité",
      "tax_cert": "Certificat fiscal",
      "bank_proof": "Justificatif bancaire"
    },
    "statusLabels": {
      "pending": "En attente",
      "approved": "Approuvé",
      "rejected": "Rejeté"
    },
    "columns": {
      "vendor": "Vendeur",
      "docType": "Type de document",
      "uploadedAt": "Téléversé le",
      "docStatus": "Statut du document",
      "rejectReason": "Motif de rejet",
      "reviewer": "Examinateur",
      "reviewedAt": "Examiné le",
      "vendorKyc": "KYC vendeur (total)",
      "actions": "Actions"
    },
    "empty": "Aucun document KYC ne correspond au filtre actuel.",
    "loading": "Chargement…",
    "payoutBlocked": "Paiement bloqué",
    "actions": {
      "viewAndReview": "Voir & examiner",
      "loadMore": "Charger plus"
    },
    "toast": {
      "accessLogTitle": "Journal d'accès",
      "accessLogFail": "Impossible de charger le journal d'accès",
      "listFail": "Impossible de charger la liste KYC",
      "approvedTitle": "Document KYC approuvé",
      "approveFail": "Impossible d'approuver le document KYC",
      "rejectedTitle": "Document KYC rejeté",
      "rejectFail": "Impossible de rejeter le document KYC",
      "errorTitle": "Erreur"
    }
  },
  "kycViewer": {
    "ariaLabel": "Visionneuse de document KYC",
    "docTypes": {
      "business_license": "Licence commerciale",
      "id_card": "Carte d'identité",
      "tax_cert": "Certificat fiscal",
      "bank_proof": "Justificatif bancaire"
    },
    "statusLabels": {
      "pending": "En attente",
      "approved": "Approuvé",
      "rejected": "Rejeté"
    },
    "description": {
      "email": "Email : {{email}}",
      "uploadedAt": "Téléversé {{date}}",
      "fileSize": "Taille {{size}}"
    },
    "statusRow": {
      "docStatus": "Statut du document :",
      "vendorKyc": "KYC vendeur :",
      "payoutBlocked": "Paiement bloqué",
      "payoutOpen": "Paiement ouvert"
    },
    "accessLog": {
      "title": "Avertissement d'accès :",
      "body": "ce document a été ouvert {{count}} fois récemment. Assurez-vous de le consulter pour une raison légitime — chaque accès est enregistré dans le journal d'audit."
    },
    "media": {
      "loading": "Chargement du document…",
      "unsupported": "Type de fichier non pris en charge pour la visualisation en ligne.",
      "download": "Télécharger ({{name}})",
      "docAlt": "Document KYC",
      "pdfTitle": "Document KYC PDF"
    },
    "review": {
      "approved": "Approuvé par {{reviewer}}",
      "rejected": "Rejeté par {{reviewer}}",
      "at": "Le {{date}}",
      "rejectReasonLabel": "Motif de rejet :"
    },
    "rejectForm": {
      "label": "Motif de rejet (obligatoire, ≥ {{min}} caractères)",
      "placeholder": "Indiquez clairement le motif de rejet afin que le vendeur puisse soumettre à nouveau correctement…",
      "charCount": "{{count}}/{{max}} caractères",
      "tooShort": "Minimum {{min}} caractères requis",
      "valid": "Valide"
    },
    "buttons": {
      "close": "Fermer",
      "cancelReject": "Annuler le rejet",
      "processing": "Traitement…",
      "confirmReject": "Confirmer le rejet",
      "reject": "Rejeter",
      "approve": "Approuver"
    }
  },
  "pendingVendors": {
    "page": {
      "heading": "Candidatures Vendeur en attente",
      "subtitle": "Examinez les réponses au sondage et approuvez ou rejetez. AC-13."
    },
    "columns": {
      "vendor": "Vendeur",
      "email": "Email",
      "country": "Pays",
      "applied": "Inscrit le",
      "survey": "Sondage",
      "surveyPending": "En attente"
    },
    "search": {
      "placeholder": "Rechercher des vendeurs…"
    },
    "empty": "Aucune candidature vendeur en attente.",
    "toast": {
      "loadFailTitle": "Impossible de charger les vendeurs en attente",
      "networkError": "Erreur réseau",
      "unknownError": "Erreur inconnue"
    }
  },
  "pendingCapabilities": {
    "noLabel": "(sans étiquette)",
    "heading": "Propositions de capacité en attente",
    "badgeAriaLabel": "{{total}} propositions en attente",
    "subtitle": "Propositions de capacité agrégées de tous les vendeurs. Actualisation automatique toutes les 30 secondes.",
    "columns": {
      "vendor": "Vendeur",
      "capability": "Capacité proposée",
      "type": "Type",
      "proposedAt": "Proposé le",
      "actions": "Actions"
    },
    "loading": "Chargement de la liste…",
    "empty": "Aucune proposition de capacité en attente",
    "actions": {
      "refresh": "Actualiser",
      "refreshing": "Chargement…",
      "review": "Examiner"
    },
    "toast": {
      "approved": "Proposition de capacité approuvée",
      "rejected": "Proposition de capacité rejetée"
    }
  },
  "createWizard": {
    "stepperAriaLabel": "Progression de la création du vendeur",
    "steps": {
      "basic": "Informations de base",
      "location_capabilities": "Localisation & capacités",
      "config": "Configuration"
    },
    "heading": "Créer un nouveau vendeur",
    "subheading": "Assistant en 3 étapes. Après la création, le vendeur sera en statut Activation en attente et devra être approuvé par un administrateur avant de recevoir des commandes.",
    "progressTitle": "Progression",
    "toast": {
      "created": {
        "title": "Vendeur créé",
        "description": "Le vendeur est en statut Activation en attente. Accédez à la liste pour approuver l'activation."
      },
      "error": {
        "title": "Impossible de créer le vendeur",
        "fallback": "La création du vendeur a échoué.",
        "unknownHttp": "Erreur inconnue (HTTP {{status}})."
      },
      "networkError": {
        "title": "Erreur réseau",
        "fallback": "Impossible de se connecter au serveur."
      }
    }
  },
  "createSteps": {
    "validation": {
      "businessNameMin": "Le nom commercial doit contenir au moins 2 caractères",
      "max120": "120 caractères maximum",
      "legalNameMin": "La raison sociale doit contenir au moins 2 caractères",
      "max160": "160 caractères maximum",
      "emailInvalid": "E-mail invalide",
      "emailTooLong": "E-mail trop long",
      "phoneMin": "Le numéro de téléphone doit comporter au moins 6 chiffres",
      "phoneTooLong": "Numéro de téléphone trop long",
      "countryIsoExample": "Code pays ISO à 2 lettres (ex. : VN, US)",
      "countryUppercase": "Le code pays doit être en majuscules",
      "timezoneInvalid": "Fuseau horaire invalide",
      "timezoneTooLong": "Fuseau horaire trop long",
      "timezoneIana": "Format IANA (ex. : Asia/Ho_Chi_Minh)",
      "locationLabelMin": "Le libellé de l'emplacement doit contenir au moins 2 caractères",
      "addressMin": "L'adresse doit contenir au moins 2 caractères",
      "cityRequired": "La ville est obligatoire",
      "countryIso": "Code pays ISO à 2 lettres",
      "mustBeInteger": "Doit être un entier",
      "capacityMax": "Maximum 100 000 commandes / jour",
      "pctRange": "Le pourcentage doit être compris entre 0 et 100",
      "capabilitiesMax": "50 capacités maximum",
      "warningLteCritical": "Avertissement (%) doit être ≤ Critique (%)",
      "surchargeMax": "Maximum 10 000 bps (100 %)",
      "notesMax": "Les notes ne doivent pas dépasser 2000 caractères"
    },
    "basicInfo": {
      "heading": "Étape 1 — Informations de base",
      "description": "Coordonnées et identité juridique du vendeur (profil principal).",
      "fields": {
        "businessName": "Nom commercial (affiché)",
        "legalName": "Raison sociale",
        "email": "E-mail de contact",
        "phone": "Numéro de téléphone",
        "country": "Code pays (ISO-2)",
        "timezone": "Fuseau horaire (IANA)",
        "language": "Langue du vendeur"
      },
      "languageOptions": {
        "vi": "Vietnamien",
        "en": "Anglais"
      },
      "actions": {
        "cancel": "Annuler",
        "next": "Continuer"
      },
      "timezonePlaceholder": "Asia/Ho_Chi_Minh"
    },
    "config": {
      "heading": "Étape 3 — Configuration & confirmation",
      "description": "Configurez le niveau de qualité et la majoration. Après la création, le vendeur sera en statut Activation en attente — il n'acceptera pas de commandes jusqu'à l'approbation d'un administrateur.",
      "review": {
        "title": "Vérifier les informations saisies",
        "businessName": "Nom commercial",
        "legalName": "Raison sociale",
        "email": "E-mail",
        "phone": "Téléphone",
        "countryTimezone": "Pays / Fuseau horaire",
        "language": "Langue",
        "capacity": "Capacité",
        "capabilities": "Capacités",
        "firstLocation": "Premier entrepôt",
        "noCapabilities": "Aucune sélection",
        "capacityDisplay": "{{capacity}} commandes/jour — avertissement {{warning}}%, critique {{critical}}%"
      },
      "fields": {
        "qualityTier": "Niveau de qualité",
        "surchargeBps": "Majoration (points de base — 100 bps = 1 %)",
        "holdPeriodTier": "Période de rétention des paiements",
        "notes": "Remarques (facultatif)"
      },
      "qualityTierOptions": {
        "standard": "Standard",
        "preferred": "Préféré",
        "premium": "Premium"
      },
      "holdPeriodOptions": {
        "7d": "7 jours",
        "14d": "14 jours",
        "30d": "30 jours"
      },
      "actions": {
        "back": "Retour",
        "creating": "Création en cours…",
        "create": "Créer le vendeur"
      }
    },
    "locationCapabilities": {
      "heading": "Étape 2 — Localisation & capacités",
      "description": "Premier entrepôt, seuils de capacité et liste des capacités d'impression. Une fois le vendeur actif, des entrepôts supplémentaires peuvent être ajoutés depuis la page de détail.",
      "capacity": {
        "title": "Seuils de capacité",
        "globalLabel": "Total commandes / jour",
        "maxConcurrentLabel": "Commandes simultanées max en traitement",
        "warningPctLabel": "Seuil d'avertissement (%)",
        "criticalPctLabel": "Seuil critique (%)"
      },
      "capabilities": {
        "title": "Capacités d'impression & d'expédition",
        "label": "Capacités d'impression (sélection multiple)",
        "groupAriaLabel": "Capacités d'impression",
        "loading": "Chargement des techniques…",
        "loadError": "Impossible de charger la liste des techniques.",
        "retry": "Réessayer"
      },
      "shippingMode": {
        "label": "Mode d'expédition",
        "options": {
          "hybrid": "Hybride",
          "self_ship": "Expédition autonome",
          "printway_processed": "Traité par Printway"
        }
      },
      "location": {
        "title": "Premier entrepôt",
        "labelField": "Nom de l'entrepôt",
        "address1": "Adresse ligne 1",
        "address2": "Adresse ligne 2 (facultatif)",
        "city": "Ville",
        "region": "État/Région (facultatif)",
        "postal": "Code postal (facultatif)",
        "country": "Pays (ISO-2)"
      },
      "actions": {
        "back": "Retour",
        "next": "Continuer"
      }
    }
  },
  "edit": {
    "heading": "Modifier le vendeur",
    "subheading": "Modification de {{name}} · toutes les modifications sont enregistrées dans le journal d'audit.",
    "savedAt": "Enregistré · {{time}}",
    "loading": "Chargement du vendeur pour modification…",
    "errors": {
      "missingVendorId": "Identifiant vendeur manquant dans l'URL.",
      "noPermission": "Vous n'avez pas la permission de modifier les vendeurs.",
      "loadFailed": "Échec du chargement du vendeur : {{message}}"
    },
    "fields": {
      "name": "Nom du vendeur",
      "legalName": "Raison sociale",
      "email": "E-mail",
      "phone": "Téléphone",
      "primaryContact": "Contact principal",
      "country": "Pays",
      "tier": "Niveau"
    },
    "reasonLabel": "Motif de la modification (obligatoire, min. 10 caractères)",
    "validation": {
      "nameRequired": "Le nom du vendeur est obligatoire.",
      "reasonRequired": "Le motif de la modification est obligatoire (minimum 10 caractères)."
    },
    "dirty": {
      "changed": "{{count}} champ(s) modifié(s)",
      "noPending": "Aucune modification en attente"
    },
    "actions": {
      "cancel": "Annuler",
      "back": "Retour au fournisseur",
      "save": "Enregistrer les modifications",
      "saving": "Enregistrement…"
    },
    "cancelDialog": {
      "title": "Abandonner les modifications non enregistrées ?",
      "description": "Le formulaire contient des modifications non enregistrées. Continuer les supprimera.",
      "keepEditing": "Continuer l'édition",
      "discard": "Abandonner les modifications"
    }
  },
  "productDetail": {
    "backLink": "← Retour au vendeur",
    "loading": "Chargement du produit…",
    "errors": {
      "notFound": "Produit introuvable (identifiant vendeur ou produit incorrect).",
      "loadFailed": "Erreur lors du chargement du produit : {{message}}"
    },
    "noName": "(sans titre)",
    "fields": {
      "baseCost": "Coût de base",
      "submission": "Soumission",
      "blueprint": "Gabarit"
    },
    "openBlueprint": "Ouvrir le gabarit →",
    "rejectReason": "Motif de rejet : {{reason}}",
    "variantsTitle": "Variantes ({{count}})",
    "noVariants": "Aucune variante.",
    "variantColumns": {
      "sku": "SKU",
      "size": "Taille",
      "color": "Couleur",
      "markup": "Majoration",
      "price": "Prix",
      "externalSku": "SKU externe"
    },
    "approvalHistory": {
      "title": "Historique d'approbation",
      "events": "{{count}} événement(s)",
      "lastEventSuffix": " · dernier : {{event}}",
      "lastEventAt": "Dernier événement le {{when}}"
    }
  },
  "bulkImport": {
    "page": {
      "heading": "Importation en masse des fournisseurs",
      "subtitle": "Téléversez un fichier CSV pour créer plusieurs fournisseurs à la fois. Tous les fournisseurs importés sont placés en Attente d'Activation et nécessitent l'approbation d'un administrateur."
    },
    "nav": {
      "ariaLabel": "Progression de l'assistant"
    },
    "stepLabels": {
      "upload": "Téléverser",
      "mapColumns": "Mapper les colonnes",
      "preview": "Aperçu",
      "commit": "Valider"
    },
    "toast": {
      "importFinished": "Importation terminée",
      "importFinishedDesc": "{{count}} fournisseur(s) créé(s) en Attente d'Activation.",
      "commitFailed": "Échec de la validation",
      "unknownError": "Erreur inconnue"
    },
    "error": {
      "missingParseTitle": "Résultat d'analyse manquant",
      "missingParseDesc": "Veuillez re-téléverser le fichier CSV.",
      "missingValidateTitle": "Résultat de validation manquant",
      "missingValidateDesc": "Veuillez relancer la validation.",
      "noCommitTitle": "Aucun résultat de validation",
      "noCommitDesc": "Veuillez recommencer l'importation.",
      "startOver": "Recommencer"
    }
  },
  "csvSteps": {
    "upload": {
      "heading": "Étape 1 — Téléverser le CSV",
      "subtitle": "Déposez un CSV ici ou cliquez sur « Parcourir les fichiers ». Fichiers jusqu'à 5 Mo.",
      "dragHere": "Faites glisser un fichier CSV ici",
      "selected": "Sélectionné : {{name}}",
      "btn": {
        "uploading": "Téléversement…",
        "browse": "Parcourir les fichiers",
        "downloadTemplate": "Télécharger le modèle"
      },
      "hint": {
        "before": "Colonnes obligatoires : name, email, phone, country (code ISO 2 lettres). Facultatif : displayName, language, timezone. Les cellules commençant par",
        "orConnector": "ou",
        "after": "verront leur premier caractère supprimé (protection anti-injection CSV)."
      },
      "toast": {
        "emptyTitle": "Le fichier CSV est vide",
        "emptyDesc": "Veuillez sélectionner un fichier contenant au moins une ligne de données.",
        "tooLargeTitle": "Le fichier CSV est trop volumineux",
        "tooLargeDesc": "Le fichier doit faire 5 Mo ou moins. Le vôtre fait {{size}} Mo.",
        "badTypeTitle": "Type de fichier non pris en charge",
        "badTypeDesc": "Veuillez choisir un fichier .csv.",
        "parseFailTitle": "Impossible d'analyser le fichier CSV",
        "unknownError": "Erreur inconnue"
      }
    },
    "mapping": {
      "heading": "Étape 2 — Mapper les colonnes",
      "subtitle": "Associez chaque colonne CSV à un champ fournisseur. Champs obligatoires : {{fields}}.",
      "skipColumn": "Ignorer la colonne",
      "fieldLabels": {
        "name": "Nom (obligatoire)",
        "email": "E-mail (obligatoire)",
        "phone": "Téléphone (obligatoire)",
        "country": "Pays (obligatoire)",
        "displayName": "Nom d'affichage",
        "language": "Langue",
        "timezone": "Fuseau horaire"
      },
      "table": {
        "csvColumn": "Colonne CSV",
        "sampleValues": "Valeurs exemples",
        "mapToField": "Associer au champ",
        "emptyHeader": "(vide)",
        "noPreview": "(aucun aperçu)"
      },
      "validation": {
        "missingRequired": "Association manquante pour le champ obligatoire : {{fields}}",
        "duplicates": "Chaque champ fournisseur ne peut être associé qu'une seule fois. Doublons : {{fields}}"
      },
      "btn": {
        "back": "Retour",
        "validate": "Valider",
        "validating": "Validation…"
      },
      "toast": {
        "validationFailed": "Échec de la validation",
        "unknownError": "Erreur inconnue"
      }
    },
    "preview": {
      "heading": "Étape 3 — Aperçu et Validation",
      "subtitle": "Résultats de la simulation. Corrigez les problèmes en revenant modifier le mappage ou votre CSV source ; sinon, procédez à la validation.",
      "stats": {
        "totalRows": "Total des lignes",
        "valid": "Valides",
        "invalid": "Invalides"
      },
      "truncatedNotice": "Affichage des {{shown}} premiers problèmes. Le nombre total d'erreurs est {{total}}. Téléchargez le rapport d'erreurs pour les inspecter.",
      "noIssues": "Aucun problème détecté. {{count}} lignes prêtes à être importées.",
      "table": {
        "rowNum": "Ligne n°",
        "issues": "Problèmes"
      },
      "btn": {
        "back": "Retour",
        "downloadErrorReport": "Télécharger le rapport d'erreurs",
        "importing": "Importation…",
        "import": "Importer {{count}} lignes valides"
      },
      "errorReportTruncatedComment": "# Tronqué — liste limitée aux {{shown}} premiers problèmes ; total des lignes invalides : {{total}}"
    },
    "commit": {
      "heading": "Étape 4 — Importation terminée",
      "subtitleOk": "Toutes les lignes valides ont été importées. Chaque nouveau fournisseur est placé en Attente d'Activation ; examinez-les dans la file d'approbation des fournisseurs.",
      "subtitlePartial": "Importation terminée avec des résultats partiels — voir ci-dessous.",
      "stats": {
        "totalRows": "Total des lignes",
        "inserted": "Insérées",
        "skipped": "Ignorées",
        "errors": "Erreurs"
      },
      "skippedReason": "ignoré — l'e-mail existe déjà ou l'insertion a échoué",
      "skippedRows": {
        "prefix": "Lignes ignorées :",
        "more": " et {{count}} de plus",
        "hint": "Cause fréquente : l'e-mail existe déjà dans la base de données. Téléchargez le rapport des lignes ignorées pour les analyser manuellement."
      },
      "btn": {
        "downloadSkipped": "Télécharger le rapport des lignes ignorées",
        "startAnother": "Démarrer une autre importation",
        "done": "Terminer"
      }
    }
  },
  "costApproval": {
    "queue": {
      "page": {
        "heading": "File d'approbation des coûts vendeurs",
        "description": "Les vendeurs soumettent des propositions de prix de production / saisonniers / majorations depuis le portail ; l'administrateur les approuve ou les rejette ici. L'ancien prix reste actif jusqu'à l'approbation de la nouvelle proposition. Chaque action est enregistrée dans le journal d'audit."
      },
      "tabs": {
        "pending": "En attente",
        "approved": "Approuvé",
        "rejected": "Rejeté",
        "all": "Tous"
      },
      "tablist": {
        "ariaLabel": "Filtrer par statut"
      },
      "filter": {
        "costTypeLabel": "Type de coût",
        "allCostTypes": "Tous les types de coût"
      },
      "costTypeLabels": {
        "production": "Production",
        "seasonal": "Saisonnière",
        "surcharge": "Majoration"
      },
      "vendorFilter": {
        "prefix": "Filtré par vendeur :",
        "clear": "Effacer le filtre"
      },
      "columns": {
        "vendor": "Vendeur",
        "variant": "Variante",
        "type": "Type",
        "current": "Actuel",
        "proposed": "Proposé",
        "delta": "Δ%",
        "proposedBy": "Proposé par",
        "submittedAt": "Soumis le",
        "actionsHeader": "Actions",
        "statusHeader": "Statut"
      },
      "loading": "Chargement…",
      "empty": "Aucune proposition de prix ne correspond aux filtres actuels.",
      "statusLabels": {
        "pending": "En attente",
        "approved": "Approuvé",
        "rejected": "Rejeté"
      },
      "toast": {
        "approveSuccess": "Proposition de prix vendeur approuvée",
        "rejectSuccess": "Proposition de prix vendeur rejetée",
        "errorTitle": "Erreur"
      },
      "errors": {
        "loadFailed": "Impossible de charger la file d'approbation",
        "approveFailed": "Impossible d'approuver la proposition",
        "rejectFailed": "Impossible de rejeter la proposition"
      }
    },
    "detail": {
      "title": "Examiner la proposition de prix vendeur",
      "closeAriaLabel": "Fermer la fenêtre",
      "costTypeLabels": {
        "production": "Production (coût de fabrication)",
        "seasonal": "Saisonnière (surcoût saisonnier)",
        "surcharge": "Majoration (frais de traitement)"
      },
      "meta": {
        "costType": "Type de coût",
        "proposedBy": "Proposé par",
        "submittedAt": "Soumis le",
        "status": "Statut"
      },
      "statusText": {
        "pending": "En attente d'approbation",
        "approved": "Approuvé · {{reviewedAt}}",
        "rejected": "Rejeté · {{reviewedAt}}"
      },
      "diff": {
        "ariaLabel": "Comparer le prix actuel et le prix proposé",
        "currentLabel": "Prix actuel (en vigueur)",
        "noCurrent": "(aucun)",
        "proposedLabel": "Prix proposé (nouveau)",
        "deltaLabel": "Écart :"
      },
      "savedRejectReason": "Motif de rejet enregistré :",
      "rejectForm": {
        "label": "Motif de rejet",
        "placeholder": "Précisez le motif afin que le vendeur puisse corriger et soumettre une nouvelle proposition.",
        "minHint": "Minimum {{min}} caractères.",
        "tooShortError": "Le motif de rejet doit comporter au moins {{min}} caractères (actuel : {{current}})."
      },
      "actions": {
        "close": "Fermer",
        "reject": "Rejeter",
        "approve": "Approuver",
        "approving": "Traitement en cours…",
        "back": "Retour",
        "submitting": "Envoi en cours…",
        "confirmReject": "Confirmer le rejet"
      }
    },
    "rowActions": {
      "statusLabels": {
        "approved": "Approuvé",
        "rejected": "Rejeté",
        "pending": "En attente"
      },
      "approveButton": "Approuver",
      "rejectButton": "Rejeter",
      "approveAriaLabel": "Approuver la proposition de prix vendeur",
      "rejectAriaLabel": "Rejeter la proposition de prix vendeur"
    }
  },
  "modals": {
    "activationApprove": {
      "title": "Approuver l'activation du vendeur",
      "descWithName": "Le vendeur <strong>{{name}}</strong> passera au statut <strong>Actif</strong> et recevra un e-mail d'activation.",
      "descGeneric": "Le vendeur passera au statut <strong>Actif</strong> et recevra un e-mail d'activation.",
      "noteLabel": "Remarque (facultatif)",
      "notePlaceholder": "Raison ou note interne — non envoyée au vendeur",
      "cancel": "Annuler",
      "submittingLabel": "Approbation en cours…",
      "submit": "Approuver",
      "networkError": "Erreur réseau — vérifier la connexion"
    },
    "activationReject": {
      "title": "Rejeter l'activation du vendeur",
      "descWithName": "Le vendeur <strong>{{name}}</strong> passera au statut <strong>Rejeté</strong> et recevra un e-mail indiquant la raison.",
      "descGeneric": "Le vendeur passera au statut <strong>Rejeté</strong> et recevra un e-mail indiquant la raison.",
      "reasonLabel": "Motif du rejet",
      "reasonPlaceholder": "Saisir le motif (minimum {{min}} caractères)…",
      "remaining": "{{count}} caractères supplémentaires requis",
      "valid": "Suffisant",
      "cancel": "Annuler",
      "submittingLabel": "Traitement en cours…",
      "submit": "Rejeter",
      "networkError": "Erreur réseau — vérifier la connexion"
    },
    "atRiskAcknowledge": {
      "title": "Accuser réception du signalement At-Risk",
      "descWithNameAndVendor": "Le signalement <strong>{{flag}}</strong> sur le vendeur <strong>{{name}}</strong> sera marqué comme examiné. Le statut du vendeur reste inchangé — vous devez encore prendre une décision séparée (suspendre / avertir / conserver).",
      "descGenericWithFlag": "Le signalement <strong>{{flag}}</strong> sera marqué comme examiné. Le statut du vendeur reste inchangé.",
      "metricsHeading": "Métriques de référence",
      "metricRatingAvg": "Note moyenne",
      "metricSampleSize": "Taille de l'échantillon",
      "metricRejectRate": "Taux de rejet",
      "metricComplaintCount": "Nombre de réclamations",
      "metricWindowHours": "Fenêtre temporelle",
      "flagLabels": {
        "low_rating": "Note faible (Low Rating)",
        "high_rejection": "Taux de rejet élevé (High Rejection)",
        "complaint_spike": "Pic de réclamations (Complaint Spike)"
      },
      "noteLabel": "Remarque (facultatif)",
      "notePlaceholder": "Raison ou décision interne — non envoyée au vendeur",
      "cancel": "Annuler",
      "submittingLabel": "Enregistrement…",
      "submit": "Accuser réception",
      "networkError": "Erreur réseau — vérifier la connexion"
    },
    "bankAccountVerify": {
      "title": "Vérifier le compte bancaire du vendeur",
      "descWithName": "Examiner les informations bancaires soumises par le vendeur <strong>{{name}}</strong>.",
      "descGeneric": "Examiner les informations bancaires soumises par le vendeur.",
      "fieldMethod": "Méthode",
      "fieldHolder": "Titulaire du compte",
      "fieldNumber": "Numéro de compte",
      "fieldBank": "Banque",
      "fieldSwift": "SWIFT",
      "fieldStatus": "Statut",
      "statusVerified": "Vérifié",
      "statusPending": "En attente de vérification",
      "alreadyVerifiedNotice": "Ce compte a déjà été vérifié. Aucune action supplémentaire n'est requise.",
      "decisionAriaLabel": "Décision",
      "decisionVerify": "Vérifier",
      "decisionReject": "Rejeter",
      "reasonLabel": "Motif du rejet",
      "reasonPlaceholder": "Saisir le motif (minimum {{min}} caractères)…",
      "remaining": "{{count}} caractères supplémentaires requis",
      "valid": "Suffisant",
      "verifyNote": "La vérification ne déclenche pas de paiement immédiat. Le vendeur doit encore atteindre le statut KYC approuvé pour débloquer les retraits.",
      "close": "Fermer",
      "cancel": "Annuler",
      "submittingLabel": "Traitement en cours…",
      "submitVerify": "Vérifier",
      "submitReject": "Rejeter",
      "networkError": "Erreur réseau — vérifier la connexion"
    },
    "capabilityAssign": {
      "title": "Attribuer une capacité au vendeur",
      "descWithName": "Attribuer une nouvelle capacité au vendeur <strong>{{name}}</strong>. La capacité prend effet immédiatement (aucune confirmation du vendeur requise).",
      "descGeneric": "Attribuer une nouvelle capacité au vendeur. La capacité prend effet immédiatement (aucune confirmation du vendeur requise).",
      "capabilityLabel": "Capacité",
      "selectAllAssigned": "— Le vendeur possède déjà toutes les capacités du catalogue —",
      "selectPlaceholder": "— Sélectionner une capacité —",
      "processingLabel": "Délai de traitement (jours)",
      "processingHint": "{{min}}…{{max}} jours",
      "capacityLabel": "Capacité / jour",
      "capacityHint": "{{min}}…{{max}} unités",
      "baseCostLabel": "Coût de base (centimes)",
      "baseCostHint": "{{min}}…{{max}} centimes",
      "cancel": "Annuler",
      "submittingLabel": "Attribution en cours…",
      "submit": "Attribuer la capacité",
      "networkError": "Erreur réseau — vérifier la connexion"
    },
    "capabilityProposal": {
      "title": "Examiner la proposition de capacité",
      "descWithNameAndBlueprint": "Le vendeur <strong>{{name}}</strong> a proposé une capacité pour le modèle <strong>{{blueprint}}</strong>.",
      "descWithName": "Le vendeur <strong>{{name}}</strong> a proposé une capacité.",
      "descGeneric": "Une proposition de capacité du vendeur est en attente d'approbation.",
      "proposalContentLabel": "Détails de la proposition",
      "decisionAriaLabel": "Décision",
      "decisionApprove": "Approuver",
      "decisionReject": "Rejeter",
      "reasonLabel": "Motif du rejet",
      "reasonPlaceholder": "Saisir le motif (minimum {{min}} caractères)…",
      "remaining": "{{count}} caractères supplémentaires requis",
      "valid": "Suffisant",
      "cancel": "Annuler",
      "submittingLabel": "Traitement en cours…",
      "submitApprove": "Approuver",
      "submitReject": "Rejeter",
      "networkError": "Erreur réseau — vérifier la connexion"
    },
    "vendorReactivate": {
      "title": "Réactiver le vendeur",
      "descWithName": "Le vendeur <strong>{{name}}</strong> sera rétabli au statut <strong>Actif</strong>. Les paiements seront débloqués et le vendeur pourra à nouveau accepter des commandes.",
      "descGeneric": "Le vendeur sera rétabli au statut <strong>Actif</strong>. Les paiements seront débloqués et le vendeur pourra à nouveau accepter des commandes.",
      "reasonLabel": "Motif de réactivation (facultatif)",
      "reasonPlaceholder": "Note interne sur le motif de réactivation — non obligatoire",
      "cancel": "Annuler",
      "submittingLabel": "Réactivation en cours…",
      "submit": "Réactiver",
      "networkError": "Erreur réseau — vérifier la connexion"
    },
    "vendorSuspend": {
      "title": "Suspendre le vendeur",
      "descWithName": "Le vendeur <strong>{{name}}</strong> sera suspendu. Les paiements seront bloqués et les commandes en attente seront interrompues jusqu'à la réactivation du vendeur.",
      "descGeneric": "Le vendeur sera suspendu. Les paiements seront bloqués et les commandes en attente seront interrompues jusqu'à la réactivation du vendeur.",
      "tierHoldPeriodPrefix": "Période de blocage :",
      "tier1Label": "7 jours",
      "tier1Desc": "La note est de 0,8 ou plus : la suspension durera 7 jours à partir de maintenant.",
      "tier2Label": "14 jours",
      "tier2Desc": "La note est comprise entre 0,5 et 0,79 (ou le vendeur n'est pas encore noté) : la suspension durera 14 jours à partir de maintenant.",
      "reasonLabel": "Motif de suspension",
      "reasonPlaceholder": "Saisir le motif (minimum {{min}} caractères)…",
      "remaining": "{{count}} caractères supplémentaires requis",
      "valid": "Suffisant",
      "cancel": "Annuler",
      "submittingLabel": "Suspension en cours…",
      "submit": "Suspendre le vendeur",
      "networkError": "Erreur réseau — vérifier la connexion",
      "tier3Label": "21 jours",
      "tier3Desc": "La note est inférieure à 0,5 : la suspension durera 21 jours à partir de maintenant."
    },
    "walletHoldRelease": {
      "holdTitle": "Bloquer le portefeuille du vendeur",
      "holdDescWithName": "Le portefeuille du vendeur <strong>{{name}}</strong> sera bloqué. Le vendeur ne pourra pas retirer des fonds ni créer de nouveaux paiements jusqu'à la levée du blocage.",
      "holdDescGeneric": "Le portefeuille du vendeur sera bloqué. Le vendeur ne pourra pas retirer des fonds ni créer de nouveaux paiements jusqu'à la levée du blocage.",
      "holdSubmit": "Bloquer le portefeuille",
      "holdSubmitting": "Blocage en cours…",
      "releaseTitle": "Débloquer le portefeuille du vendeur",
      "releaseDescWithName": "Le portefeuille du vendeur <strong>{{name}}</strong> sera débloqué. Le vendeur pourra créer des paiements / retirer des fonds normalement.",
      "releaseDescGeneric": "Le portefeuille du vendeur sera débloqué. Le vendeur pourra créer des paiements / retirer des fonds normalement.",
      "releaseSubmit": "Débloquer le portefeuille",
      "releaseSubmitting": "Déblocage en cours…",
      "reasonLabel": "Motif",
      "reasonMinHint": "(minimum {{min}} caractères)",
      "holdPlaceholder": "Motif du blocage — consigné dans l'audit, non envoyé au vendeur",
      "releasePlaceholder": "Motif du déblocage — consigné dans l'audit, non envoyé au vendeur",
      "remaining": "{{count}} caractères supplémentaires requis",
      "cancel": "Annuler",
      "networkError": "Erreur réseau — vérifier la connexion"
    },
    "walletAdjustment": {
      "networkError": "Erreur réseau — vérifier la connexion"
    }
  },
  "settings": {
    "title": "Paramètres Fournisseur",
    "subtitle": "Configurer l’allocation et le mappage au niveau fournisseur.",
    "tablistAria": "Onglets des paramètres fournisseur",
    "tabs": {
      "mapping": "Mappage"
    }
  },
  "catalog": {
    "pageTitle": "Fournisseur",
    "pageSubtitle": "Gérez vos partenaires fournisseurs, leurs informations et leurs capacités de production.",
    "searchPlaceholder": "Rechercher un fournisseur...",
    "statusAll": "Statut : tous",
    "statusActive": "Statut : actif",
    "statusInactive": "Statut : inactif",
    "create": "Créer",
    "colName": "Nom",
    "colCode": "Code",
    "colLocation": "Localisation",
    "colCreatedDate": "Date de création",
    "colLastUpdate": "Dernière mise à jour",
    "colCreator": "Créateur",
    "colLastEditor": "Modifié en dernier par",
    "colStatus": "Statut",
    "colActions": "Action",
    "loading": "Chargement des fournisseurs…",
    "loadError": "Échec du chargement des fournisseurs.",
    "retry": "Réessayer",
    "emptyNone": "Aucun fournisseur pour le moment.",
    "emptySearch": "Aucun fournisseur ne correspond à cette recherche.",
    "rowsPerPage": "Lignes par page :",
    "showingRange": "Affichage {{from}}–{{to}} sur {{total}} fournisseurs",
    "prevPage": "Page précédente",
    "nextPage": "Page suivante",
    "paginationAria": "Pagination de la liste des fournisseurs",
    "statusToggleAria": "Changer le statut de {{name}}",
    "editAria": "Modifier {{name}}",
    "productsAria": "Voir les produits de {{name}}",
    "statusSaved": "Statut enregistré.",
    "statusFailed": "Impossible de changer le statut",
    "manageLink": "Vue avancée",
    "toggleReason": "Statut modifié depuis la liste des fournisseurs par un administrateur.",
    "statusError": {
      "notFound": "Ce fournisseur n'existe plus, ou n'est pas un compte fournisseur.",
      "stateInvalid": "Seul un fournisseur suspendu peut être réactivé — celui-ci ne l'est pas.",
      "alreadySuspended": "Ce fournisseur est déjà suspendu.",
      "internal": "Le serveur n'a pas pu effectuer la modification. Réessayez, ou contactez le support si cela persiste.",
      "generic": "Le serveur a refusé la modification sans indiquer pourquoi."
    }
  },
  "productsSheet": {
    "title": "Produits — {{vendor}}",
    "subtitle": "Produits que ce fournisseur peut fabriquer et expédier.",
    "close": "Fermer",
    "authLoading": "Vérification de vos autorisations…",
    "authError": "Impossible de charger vos autorisations, la modification est donc indisponible.",
    "authRetry": "Réessayer",
    "searchPlaceholder": "Rechercher un produit...",
    "colProductType": "Type de produit",
    "colProductCode": "Code produit",
    "colDateCreated": "Date de création",
    "colUserCreated": "Créé par",
    "colStatus": "Statut",
    "loading": "Chargement des produits…",
    "loadError": "Échec du chargement des produits de ce fournisseur.",
    "emptyNone": "Ce fournisseur n’a encore aucun produit.",
    "emptySearch": "Aucun produit ne correspond à cette recherche.",
    "showingRange": "Affichage {{from}}–{{to}} sur {{total}} produits",
    "statusToggleAria": "Activer ou désactiver {{name}}",
    "statusSaved": "Statut du produit mis à jour.",
    "statusError": "Impossible de modifier le statut du produit.",
    "statusConflict": "L'état de ce produit vient de changer. Rechargez puis réessayez.",
    "statusLocked": "Les produits en attente ou refusés passent par le circuit d'approbation.",
    "confirmOffTitle": "Désactiver ce produit ?",
    "confirmOffBody": "{{name}} est désactivé immédiatement, sans attendre le préavis de 7 jours du fournisseur.",
    "confirmOff": "Désactiver",
    "cancel": "Annuler",
    "openSkusAria": "Ouvrir les SKU de {{name}}",
    "statusFilterAll": "Statut : Tous",
    "statusFilterActive": "Statut : Actif",
    "statusFilterInactive": "Statut : Inactif",
    "refreshing": "Actualisation…",
    "skus": {
      "back": "Retour aux produits",
      "subtitle": "Gérez les SKU, les prix, les dimensions et les frais d'expédition de ce produit.",
      "searchPlaceholder": "Rechercher des SKU...",
      "bulkOrder": "Commande en gros",
      "bulkAllAria": "Commande en gros pour tous les SKU de ce produit",
      "bulkPartial": "{{count}}/{{total}}",
      "bulkConfirmOnTitle": "Activer la commande en gros pour tous les SKU ?",
      "bulkConfirmOffTitle": "Désactiver la commande en gros pour tous les SKU ?",
      "bulkConfirmBody": "Cela modifie les {{total}} SKU du produit, y compris ceux absents de cette page.",
      "bulkConfirm": "Appliquer",
      "bulkSaved": "Commande en gros mise à jour pour {{count}} SKU.",
      "colSkuName": "Nom du SKU",
      "colSkuCode": "Code SKU",
      "colCostPrice": "Prix de revient",
      "colHandleFee": "Frais de manutention",
      "colDimension": "Dimensions",
      "colShippingInfo": "Expédition",
      "colBulkOrder": "En gros",
      "colStatus": "Statut",
      "dimensionValue": "{{l}} × {{w}} × {{h}} cm · {{g}} g",
      "editDimensionsAria": "Modifier les dimensions de {{sku}}",
      "view": "Voir",
      "hide": "Masquer",
      "shippingToggleAria": "Infos d'expédition de {{sku}}",
      "skuStatusAria": "Activer ou désactiver le SKU {{sku}}",
      "skuBulkAria": "Commande en gros pour le SKU {{sku}}",
      "saved": "SKU mis à jour.",
      "saveError": "Impossible d'enregistrer le SKU.",
      "loading": "Chargement des SKU…",
      "loadError": "Échec du chargement des SKU de ce produit.",
      "emptyNone": "Ce produit n'a pas encore de SKU.",
      "emptySearch": "Aucun SKU ne correspond.",
      "showingRange": "{{from}}–{{to}} sur {{total}} SKU",
      "linkMapped": "Mappé · en attente",
      "linkAllocated": "Lié · alloué",
      "linkNoAllocation": "Lié · sans allocation"
    },
    "dimensions": {
      "title": "Définir les dimensions",
      "subtitle": "Configurer les dimensions du colis",
      "weight": "Poids",
      "boxHeight": "Hauteur du colis",
      "boxWidth": "Largeur du colis",
      "boxLength": "Longueur du colis",
      "unitG": "g",
      "unitCm": "cm",
      "save": "Enregistrer",
      "cancel": "Annuler",
      "invalid": "Saisissez un nombre supérieur à 0.",
      "rejected": "Cette valeur n'a pas été acceptée. Vérifiez-la et réessayez.",
      "saved": "Dimensions enregistrées."
    },
    "shipping": {
      "colService": "Service",
      "colShippingFee": "Frais d'expédition",
      "colShippingCost": "Coût d'expédition",
      "colTariff": "Droit réciproque",
      "colAdditionalFee": "Frais supplémentaires",
      "colAdditionalCost": "Coût supplémentaire",
      "colStatus": "Statut",
      "emptyMethods": "Aucun service d'expédition actif. Ajoutez-en un dans Vendors → Services.",
      "statusAria": "{{service}} pour ce SKU",
      "invalidAmount": "Saisissez un montant comme 5.00",
      "feeAria": "{{field}} — {{service}}",
      "required": "Obligatoire",
      "unsavedSummary": "Non enregistré : {{changes}} sur {{skus}}",
      "unsavedChanges_one": "{{count}} modification non enregistrée",
      "unsavedChanges_other": "{{count}} modifications non enregistrées",
      "skuCount_one": "{{count}} SKU",
      "skuCount_other": "{{count}} SKU",
      "invalidCount_one": "{{count}} champ à corriger",
      "invalidCount_other": "{{count}} champs à corriger",
      "invalidElsewhere": "Sur une autre page ou un autre filtre : {{skus}}",
      "saveAll": "Enregistrer les modifications",
      "discardAll": "Annuler les modifications",
      "savedBatch_one": "{{count}} ligne d'expédition enregistrée.",
      "savedBatch_other": "{{count}} lignes d'expédition enregistrées.",
      "savedNothing": "Aucune modification.",
      "leaveTitle": "Modifications non enregistrées",
      "leaveBody_one": "Vous avez {{count}} modification non enregistrée. L’enregistrer avant de quitter ?",
      "leaveBody_other": "Vous avez {{count}} modifications non enregistrées. Les enregistrer avant de quitter ?",
      "leaveSave": "Enregistrer et continuer",
      "leaveDiscard": "Abandonner",
      "leaveStay": "Rester",
      "leaveInvalid": "Certains champs sont invalides — corrigez-les ou abandonnez les modifications.",
      "editedAria": "modifié",
      "saveError": "Impossible d'enregistrer les modifications d'expédition.",
      "rowRefused": "Non enregistrée — cette ligne a été refusée.",
      "discardRow": "Abandonner cette ligne",
      "markDraft": "modifications d'expédition non enregistrées",
      "markError": "champs d'expédition à corriger"
    },
    "pricing": {
      "costAria": "Prix de revient de {{sku}}",
      "handleAria": "Frais de manutention de {{sku}}",
      "costLocked": "Ce produit attend une validation — le prix de revient est verrouillé jusqu’à la revue.",
      "required": "Obligatoire",
      "invalidAmount": "Saisissez un montant comme 5.00",
      "savedBatch_one": "Prix de {{count}} SKU enregistré.",
      "savedBatch_other": "Prix de {{count}} SKU enregistrés.",
      "savedAll": "Prix et expédition enregistrés.",
      "partialSaved": "Prix enregistrés ; les modifications d’expédition ne l’ont pas été.",
      "saveError": "Impossible d’enregistrer les prix. Rien n’a été enregistré.",
      "errCostGuard": "Le coût doit rester inférieur au prix marchand le plus bas.",
      "errCostGuardTier": "Le coût doit rester inférieur au prix marchand le plus bas ({{tier}}).",
      "errPending": "Le produit attend une validation — le coût ne peut pas changer.",
      "errConfigNotApproved": "Le lien Printway de ce SKU attend une validation.",
      "errPricingMissing": "Le SKU Printway n’a pas encore de prix marchand.",
      "errNotFound": "Ce SKU n’existe plus.",
      "errRefused": "Non enregistré — cette valeur a été refusée."
    }
  },
  "services": {
    "pageTitle": "Services",
    "pageSubtitle": "Gérez vos services d’expédition, modes de livraison et configurations de transit.",
    "searchPlaceholder": "Rechercher un service...",
    "create": "Créer",
    "colImage": "Image",
    "colName": "Nom du service",
    "colCode": "Code du service",
    "colDescription": "Description",
    "colShippingTime": "Délai d’expédition",
    "colStatus": "Statut",
    "colActions": "Action",
    "loading": "Chargement des services…",
    "loadError": "Échec du chargement des services.",
    "retry": "Réessayer",
    "emptyNone": "Aucun service d’expédition pour le moment.",
    "emptySearch": "Aucun service ne correspond à cette recherche.",
    "rowsPerPage": "Lignes par page :",
    "showingRange": "Affichage {{from}}–{{to}} sur {{total}} services",
    "prevPage": "Page précédente",
    "nextPage": "Page suivante",
    "paginationAria": "Pagination de la liste des services",
    "statusToggleAria": "Changer le statut de {{name}}",
    "editAria": "Modifier {{name}}",
    "statusSaved": "Statut enregistré.",
    "statusFailed": "Impossible de changer le statut",
    "carrierHint": "Pas encore associé à un transporteur — associez-le dans Expédition › Configuration › Service.",
    "breadcrumbServices": "Services",
    "breadcrumbShipping": "Expédition",
    "breadcrumbCreate": "Créer",
    "breadcrumbEdit": "Modifier",
    "createTitle": "Créer un service d’expédition",
    "createSubtitle": "Ajouter un nouveau service d’expédition au système.",
    "editTitle": "Modifier le service d’expédition",
    "editSubtitle": "Mettre à jour ce service d’expédition.",
    "sectionInfo": "Informations du service",
    "imageLabel": "Image du service",
    "imageCta": "Cliquez pour téléverser ou glissez-déposez",
    "imageHint": "PNG, JPG jusqu’à 2 Mo (ratio 1:1 recommandé)",
    "imageRemove": "Retirer l’image",
    "imageTooLarge": "Cette image dépasse 2 Mo.",
    "imageWrongType": "Seules les images PNG et JPG sont acceptées.",
    "nameLabel": "Nom du service",
    "namePlaceholder": "Saisissez le nom du service",
    "codeLabel": "Code du service",
    "codePlaceholder": "ex. STD-SHP",
    "codeHint": "Un code unique pour identifier ce service.",
    "codeLockedHint": "Le code du service ne peut plus être changé après la création.",
    "descriptionLabel": "Description",
    "descriptionPlaceholder": "Saisissez une brève description de ce service d’expédition",
    "shippingTimeLabel": "Délai d’expédition",
    "shippingTimePlaceholder": "ex. 7-14 jours",
    "shippingTimeHint": "Fourchette de délai de livraison estimée.",
    "statusLabel": "Statut",
    "statusActive": "Actif",
    "statusInactive": "Inactif",
    "statusDraft": "Brouillon",
    "cancel": "Annuler",
    "submitCreate": "Créer le service",
    "submitSave": "Enregistrer",
    "saving": "Enregistrement…",
    "created": "Service créé.",
    "updated": "Service enregistré.",
    "nameRequired": "Le nom du service est obligatoire",
    "codeRequired": "Le code du service est obligatoire",
    "codeFormat": "Le code doit contenir des majuscules, chiffres, - ou _ (2 à 40 caractères)",
    "codeDuplicate": "Un autre service utilise déjà ce code",
    "shippingTimeRequired": "Le délai d’expédition est obligatoire",
    "createFailed": "Impossible de créer le service",
    "updateFailed": "Impossible d’enregistrer le service",
    "loadFailed": "Impossible de charger ce service"
  }
}
